import * as React from "react";
import {isNullOrUndefined} from "util";

const classNames = require('classnames');

interface Props {
	/**
	 * Additional custom class.
	 */
	customClass?: string;
}

/**
 * White section.
 */
export default class SectionView extends React.PureComponent<Props, {}> {

	render() {

		const classes = classNames({
			"l-page-section": true,
			[`${this.props.customClass}`]: !isNullOrUndefined(this.props.customClass)
		});

		return (
			<div className={classes}>{this.props.children}</div>
		);
	}
}